export enum WikiLink {
  Customize = 'https://wiki.kavitareader.com/guides/features/customization',
  CustomizeExternalSource = 'https://wiki.kavitareader.com/guides/features/customization#external-source',
  ReadingLists = 'https://wiki.kavitareader.com/guides/features/readinglists',
  Collections = 'https://wiki.kavitareader.com/guides/features/collections',
  SeriesRelationships = 'https://wiki.kavitareader.com/guides/features/relationships',
  Bookmarks = 'https://wiki.kavitareader.com/guides/features/bookmarks',
  DataCollection = 'https://wiki.kavitareader.com/troubleshooting/faq#q-does-kavita-collect-any-data-on-me',
  MediaIssues = 'https://wiki.kavitareader.com/guides/admin-settings/media#media-issues',
  KavitaPlusDiscordId = 'https://wiki.kavitareader.com/guides/admin-settings/kavita+#discord-id',
  KavitaPlus = 'https://wiki.kavitareader.com/guides/admin-settings/kavita+',
  KavitaPlusFAQ = 'https://wiki.kavitareader.com/kavita+/faq',
  ReadingListCBL = 'https://wiki.kavitareader.com/guides/features/readinglists#creating-a-reading-list-via-cbl',
  Donation = 'https://wiki.kavitareader.com/donating',
  Updating = 'https://wiki.kavitareader.com/guides/updating',
  ManagingFiles = 'https://wiki.kavitareader.com/guides/scanner/managefiles',
  Scanner = 'https://wiki.kavitareader.com/guides/scanner',
  ScannerExclude = 'https://wiki.kavitareader.com/guides/admin-settings/libraries#exclude-patterns',
  Library = 'https://wiki.kavitareader.com/guides/admin-settings/libraries',
  UpdateNative = 'https://wiki.kavitareader.com/guides/updating/updating-native',
  UpdateDocker = 'https://wiki.kavitareader.com/guides/updating/updating-docker'
}
